import type { ComponentType, PropsWithChildren, ReactNode } from 'react';

import { ThemeProvider as DesignThemeProvider } from '../design-system/index.js';
import '../design-system/tokens.css';
import { PlayerProvider, type ResolvePlaybackSource } from '../player/player-context.js';

export type ThemeProviderLike = ComponentType<PropsWithChildren>;

export function AppProviders({
  children,
  playbackPersistenceScope = null,
  resolvePlaybackSource,
  themeProvider: ThemeProvider = DesignThemeProvider,
}: {
  children: ReactNode;
  playbackPersistenceScope?: string | null;
  resolvePlaybackSource: ResolvePlaybackSource;
  themeProvider?: ThemeProviderLike;
}) {
  return (
    <ThemeProvider>
      <PlayerProvider
        persistenceScope={playbackPersistenceScope}
        resolveSource={resolvePlaybackSource}
      >
        {children}
      </PlayerProvider>
    </ThemeProvider>
  );
}
